<template>
  <div :class="$style.sectionTop">
    <div class="container--big">
      <h1 class="title"
        >預約智能化，管理沒煩惱，<br class="mobile-only" />
        共創美業新世代</h1
      >
      <p class="sub-title">顧客預約、會員管理、人員安排、<br class="mobile-only" />訊息推播、行銷經營、數據分析<br />通通交給愛美訂 為您搞 DING</p>
      <router-link :to="{ path: '/', hash: 'sectionContact' }" class="dingbeauty-btn">
        <img class="email-icon" src="@src/assets/dingbeauty-images/contact/icon_mail_white.svg" alt="" />專人聯繫</router-link
      >
      <img class="device" src="@assets/images/home/device_v2@2x.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
.sectionTop {
  height: 78vh;
  background: rgb(255, 254, 252);
  background: linear-gradient(90deg, rgba(255, 254, 252, 1) 0%, rgba(253, 246, 235, 1) 100%);
  text-align: center;
  padding-top: 120px;
  margin-bottom: 40px;

  :global {
    .title {
      font-size: 24px;
      margin-bottom: 20px;
      color: #0c1c30;
      line-height: 1.7;
    }

    .sub-title {
      margin-bottom: 8px;
      font-size: 14px;
      color: #0c1c30;
      line-height: 2;
    }

    .device {
      width: 100%;
      max-width: 800px;
    }

    .dingbeauty-btn {
      width: auto;
      max-width: 280px;
      margin-top: 32px;
      margin-bottom: 80px;
    }
  }
}

@media (min-width: 576px) {
  .sectionTop {
    height: 80vh;
    padding-top: 80px;

    :global {
      .title {
        font-size: 30px;
        margin-bottom: 24px;
        color: #0c1c30;
      }

      .mobile-only {
        display: none;
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionTop {
    height: 87vh;
  }
}

@media (min-width: 992px) {
  .sectionTop {
    padding-top: 160px;
    height: 105vh;
    margin-bottom: 120px;

    :global {
      .title {
        font-size: 50px;
      }

      .sub-title {
        font-size: 16px;
      }

      .dingbeauty-btn {
        margin-bottom: 100px;
      }
    }
  }
}
</style>
